<template lang="pug">
form(onsubmit="return false")
  .form-group.has-success
    <label>Title*</label>
    input.form-control(placeholder="Enter video title" v-model.trim="video.title")
  .form-group
    label
      | Description
    textarea.form-control(placeholder="Enter Description (optional)" rows="4" v-model.trim="video.description")
</template>
<script>
export default {
  name: 'VideoUpload',
  props: {
    video: {
      type: Object,
      default () {
        return {
          title: '',
          description: '',
          path: ''
        }
      }
    }
  },
  watch: {
    video: {
      handler (newObj, oldObj) {
        this.$emit('videoDetailsUpdated', newObj)
      },
      deep: true
    }
  },
  methods: {
    setVideoPath (path) {
      this.video.path = path
    },
    reset () {
      this.video = {}
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/features/dashboard/components/status-update/video.vue